import { PropsWithChildren } from 'react';

import { LinkStoryblok, Locales } from '@monoimin/sb-types';
import { passLocale } from '@monoimin/utils/helpers';

type LinkBlokWrapperProps = PropsWithChildren<{
  item: LinkStoryblok;
  locale: Locales;
}>;

export const LinkBlockWrapper = ({
  item,
  locale,
  children,
}: LinkBlokWrapperProps) => {
  const { forLanguages } = item;

  const isPassLink = forLanguages?.length
    ? passLocale(locale, forLanguages)
    : true;

  if (isPassLink) {
    return <>{children}</>;
  }

  return null;
};

export default LinkBlockWrapper;
